export default [
    {
        name: 'environmentMapTexture',
        type: 'cubeTexture',
        path:
        [
            'textures/bathroom/px.png',
            'textures/bathroom/nx.png',
            'textures/bathroom/py.png',
            'textures/bathroom/ny.png',
            'textures/bathroom/pz.png',
            'textures/bathroom/nz.png'
        ]
    }
]